import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { CacheService } from "@vp/shared/services/cache";
import { API_BASE_URL } from "@vp/shared/tokens";

import { JSONSchema7 } from "json-schema";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class JsonSchemaApiService {
  constructor(
    @Inject(API_BASE_URL) private apiBaseUrl: string,
    private cacheService: CacheService<JSONSchema7>,
    private http: HttpClient
  ) {}

  get = (name: string): Observable<JSONSchema7> => {
    if (!this.cacheService.has(`UiSchemaApiService.${name}`)) {
      return this.getInternal(name).pipe(
        tap((schema: JSONSchema7) => {
          this.cacheService.set(`UiSchemaApiService.${name}`, schema);
        })
      );
    }
    return this.cacheService.get(`UiSchemaApiService.${name}`, this.getInternal(name));
  };

  private getInternal = (name: string) => {
    return this.http.get<JSONSchema7>(`${this.apiBaseUrl}/schema/${name}`);
  };
}
